export const appMode = [
  'bloom',
  'default',
  'embedded',
  'framelessEmbed',
  'headless',
  'kiosk',
  'operatorEmbed',
  'whiteLabel',
] as const;

export type AppMode = (typeof appMode)[number];

export const isEmbeddedMode = (appMode?: AppMode) => {
  // Please inform the Ads team when updating this list. Coverage in placement.rb needs to be updated.
  return [
    'bloom',
    'embedded',
    'framelessEmbed',
    'headless',
    'operatorEmbed',
    'whiteLabel',
  ].includes(appMode ?? '');
};
